export const logError = (...args: unknown[]): void => console.error(...args);

export const logWarn = (...args: unknown[]): void => console.warn(...args);
